module.exports = __webpack_public_path__ + "39b00b5d82a4316cfe2373137970aa62.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/TK.svg
// module id = UYw9
// module chunks = 0